export { default } from "./ShopByRoom";
